import {segmentProps} from "./segmentProps";
import {isNil, mapKeys, omitBy} from "lodash";
import {getDeviceProp} from "../helpers/SegmentHelpers";

export const trackEvent = async (eventName, props = {}) => {
    // device information gets added with every track event
    props = {
        ...props,
        ...getDeviceProp()
    }

    if (props) {
        props = JSON.parse(JSON.stringify(props, (_, v) => (v === undefined ? null : v)))
    }

    // mapping props key to constant file
    if (props) props = mapKeys(props, (v, k) => segmentProps[k] || k)

    if (props) props = omitBy(props, isNil)

    // fetching event name which is stored in redux state by its key
    if (eventName && window.klaviyo) {
        var response = await window.klaviyo.track(eventName, props)
        return response
    }
    return null
}

export const identifyEvent = async ({
                                        traits = {},
                                        userId,
                                        onSuccess = () => {
                                        },
                                        replaceUndefinedOrNullValues = true
                                    }) => {

    // device information gets added with every track event
    traits = {
        ...traits,
        ...getDeviceProp()
    }
    // mapping props key to constant file
    traits = mapKeys(traits, (v, k) => segmentProps[k] || k)
    if (window.klaviyo) {
        const response = await window.klaviyo.identify(traits)
        return response
    }

    return null
}
